import { apiClient } from 'api/APIClient';
import { Person } from 'api/Community/CommunityInterfaces';


export const getLinkedPeopleFromInteraction = async (interaction_type: string, interaction_id: number): Promise<Person[]> => {
  const { data } = await apiClient.get<Person[]>(`/interactions/${interaction_type}/${interaction_id}/people/`);
  return data;
};

export const getLinkedAddressesFromInteraction = async (interaction_type: string, interaction_id: number): Promise<Person[]> => {
  const { data } = await apiClient.get<Person[]>(`/interactions/${interaction_type}/${interaction_id}/addresses/`);
  return data;
};